/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconEfficacyAddOn = (props) => (
  <SVG
    width="98"
    height="81"
    viewBox="0 0 98 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M55.0134 17.1815H5.021V49.1991H55.0134V17.1815Z" fill="#F2F2F2" />
    <g filter="url(#filter0_d_32_1763)">
      <path d="M53.5878 20.6476H6.4541V46.7552H53.5878V20.6476Z" fill="white" />
    </g>
    <path d="M54.9924 19.4245H5V21.5484H54.9924V19.4245Z" fill="#53B095" />
    <path
      d="M6.57799 20.8264C6.79527 20.8264 6.97141 20.6503 6.97141 20.433C6.97141 20.2157 6.79527 20.0396 6.57799 20.0396C6.36071 20.0396 6.18457 20.2157 6.18457 20.433C6.18457 20.6503 6.36071 20.8264 6.57799 20.8264Z"
      fill="white"
    />
    <path
      d="M8.07262 20.8264C8.2899 20.8264 8.46604 20.6503 8.46604 20.433C8.46604 20.2157 8.2899 20.0396 8.07262 20.0396C7.85534 20.0396 7.6792 20.2157 7.6792 20.433C7.6792 20.6503 7.85534 20.8264 8.07262 20.8264Z"
      fill="white"
    />
    <path
      d="M9.56627 20.8264C9.78355 20.8264 9.9597 20.6503 9.9597 20.433C9.9597 20.2157 9.78355 20.0396 9.56627 20.0396C9.34899 20.0396 9.17285 20.2157 9.17285 20.433C9.17285 20.6503 9.34899 20.8264 9.56627 20.8264Z"
      fill="white"
    />
    <path
      d="M22.8452 23.1777H10.7339V43.8673H22.8452V23.1777Z"
      fill="#F2F2F2"
    />
    <path d="M30.316 24.4684H20.2231V30.1638H30.316V24.4684Z" fill="#53B095" />
    <path d="M30.316 30.0797H20.2231V36.2069H30.316V30.0797Z" fill="#F2F2F2" />
    <path d="M30.316 36.1043H20.2231V41.7996H30.316V36.1043Z" fill="#F2F2F2" />
    <path
      d="M41.5395 24.2182H29.4282V33.2349H41.5395V24.2182Z"
      fill="#F2F2F2"
    />
    <path
      d="M41.5395 33.1843H29.4282V42.2009H41.5395V33.1843Z"
      fill="#F2F2F2"
    />
    <path
      d="M93.3771 17.1815H43.3848V49.1991H93.3771V17.1815Z"
      fill="#F2F2F2"
    />
    <g filter="url(#filter1_d_32_1763)">
      <path
        d="M91.9462 20.6476H44.8125V46.7552H91.9462V20.6476Z"
        fill="white"
      />
    </g>
    <path
      d="M93.3561 19.4245H43.3638V21.5484H93.3561V19.4245Z"
      fill="#53B095"
    />
    <path
      d="M55.3524 20.8264C55.5697 20.8264 55.7458 20.6503 55.7458 20.433C55.7458 20.2157 55.5697 20.0396 55.3524 20.0396C55.1351 20.0396 54.959 20.2157 54.959 20.433C54.959 20.6503 55.1351 20.8264 55.3524 20.8264Z"
      fill="white"
    />
    <path
      d="M56.5233 20.8264C56.7406 20.8264 56.9167 20.6503 56.9167 20.433C56.9167 20.2157 56.7406 20.0396 56.5233 20.0396C56.306 20.0396 56.1299 20.2157 56.1299 20.433C56.1299 20.6503 56.306 20.8264 56.5233 20.8264Z"
      fill="white"
    />
    <path
      d="M57.6937 20.8264C57.911 20.8264 58.0871 20.6503 58.0871 20.433C58.0871 20.2157 57.911 20.0396 57.6937 20.0396C57.4764 20.0396 57.3003 20.2157 57.3003 20.433C57.3003 20.6503 57.4764 20.8264 57.6937 20.8264Z"
      fill="white"
    />
    <path d="M87.6542 23.1777H75.543V43.8673H87.6542V23.1777Z" fill="#F2F2F2" />
    <path
      d="M78.9891 24.4677H54.5605V30.1631H78.9891V24.4677Z"
      fill="#53B095"
    />
    <path
      d="M78.9891 30.0797H54.5605V36.2069H78.9891V30.0797Z"
      fill="#F2F2F2"
    />
    <path
      d="M78.9891 36.1043H54.5605V41.7996H78.9891V36.1043Z"
      fill="#F2F2F2"
    />
    <path d="M48.9967 0H48.7173V15.2672H48.9967V0Z" fill="#CCCCCC" />
    <path
      d="M77.0316 24.7685H76.7522V15.4069H21.1422V24.7685H20.8628V15.1275H77.0316V24.7685Z"
      fill="#CCCCCC"
    />
    <path
      d="M50.8653 33.8158L50.6515 32.7638C50.6515 32.7638 47.5568 31.7118 47.2104 33.8158H50.8653Z"
      fill="#E6E6E6"
    />
    <path
      d="M46.1655 78.8725H44.1364L43.1714 71.0469H46.1648L46.1655 78.8725Z"
      fill="#FFB8B8"
    />
    <path
      d="M47.0128 80.8396H40.4707V80.7569C40.4707 80.0816 40.739 79.4338 41.2166 78.9563C41.6941 78.4787 42.3419 78.2104 43.0173 78.2104H47.0135L47.0128 80.8396Z"
      fill="#2F2E41"
    />
    <path
      d="M50.9365 78.8725H52.9657L53.9307 71.0469H50.9372L50.9365 78.8725Z"
      fill="#FFB8B8"
    />
    <path
      d="M50.103 78.2104H54.0942C54.7695 78.2104 55.4171 78.4786 55.8947 78.956C56.3722 79.4334 56.6406 80.081 56.6408 80.7562V80.8389H50.103V78.2104Z"
      fill="#2F2E41"
    />
    <path
      d="M52.5154 34.5277L54.8296 34.3139L56.3021 41.2572L56.0883 47.5691L53.7741 55.9856L50.6182 54.0919L52.3016 45.468L52.5154 34.5277Z"
      fill="#2F2E41"
    />
    <path
      d="M55.4521 46.0902L54.9339 50.5091L55.5654 60.8193V76.1834L51.5678 75.9696L50.726 59.979L48.4118 52.6151L46.7284 61.0317L45.6764 76.812L41.5733 76.4835V60.9732L41.4678 49.6666L42.9403 45.2477L55.4521 46.0902Z"
      fill="#2F2E41"
    />
    <path
      d="M46.7014 30.8437C46.7014 30.8437 48.1739 28.7397 50.9065 30.2122L52.1687 31.8957L56.1664 34.8413L55.3246 44.7303L56.3766 57.1445L41.438 56.9307L43.9632 44.5165V31.2599L46.7014 30.8437Z"
      fill="#2F2E41"
    />
    <path
      opacity="0.25"
      d="M53.4088 37.9816L54.6154 52.4064L53.0938 44.5886L53.4088 37.9816Z"
      fill="black"
    />
    <path
      d="M45.2121 57.0334C45.3578 56.8594 45.4636 56.6556 45.522 56.4364C45.5804 56.2171 45.59 55.9876 45.5501 55.7643C45.5102 55.5409 45.4218 55.329 45.2911 55.1435C45.1604 54.958 44.9907 54.8034 44.7938 54.6906L45.2435 51.1733L43.1723 50.3787L42.6071 55.3549C42.4391 55.6982 42.4029 56.0912 42.5054 56.4594C42.608 56.8276 42.8421 57.1453 43.1634 57.3523C43.4847 57.5593 43.8707 57.6412 44.2484 57.5824C44.626 57.5236 44.969 57.3282 45.2121 57.0334Z"
      fill="#FFB8B8"
    />
    <path
      d="M42.5547 53.9964H45.9209V52.5232H42.5547V53.9964Z"
      fill="#E6E6E6"
    />
    <path
      d="M47.381 33.0667L45.1716 31.2784C45.1716 31.2784 43.5936 31.173 43.3834 33.4879C43.1731 35.8028 42.9172 45.6911 42.9172 45.6911L42.1211 55.5801L46.54 55.7939L47.3817 45.0903L47.381 33.0667Z"
      fill="#2F2E41"
    />
    <path
      d="M52.7184 30.9992C53.8377 28.9518 53.0852 26.3847 51.0377 25.2654C48.9902 24.1462 46.4231 24.8987 45.3039 26.9461C44.1847 28.9936 44.9371 31.5607 46.9846 32.6799C49.0321 33.7992 51.5992 33.0467 52.7184 30.9992Z"
      fill="#FFB8B8"
    />
    <path
      d="M48.6913 32.6954C49.7243 32.9421 50.8122 32.7964 51.7439 32.2866C52.6757 31.7768 53.3849 30.9391 53.7341 29.936C54.0833 28.933 54.0476 27.836 53.6339 26.8578C53.2202 25.8796 52.458 25.0898 51.4951 24.6416C50.7528 24.3091 49.9406 24.1624 49.1289 24.214C47.8652 24.2803 46.6343 24.7478 45.3721 24.7129L45.189 25.0072L44.4984 24.8398L44.3501 25.3886L44.1684 25.3821C44.1009 25.536 44.0714 25.7037 44.0823 25.8714C44.0933 26.039 44.1443 26.2015 44.2313 26.3452C44.3182 26.4889 44.4384 26.6097 44.5817 26.6972C44.7251 26.7847 44.8874 26.8365 45.0549 26.8482C45.3254 26.8171 45.5921 26.7591 45.8511 26.675C45.9812 26.6343 46.1197 26.6274 46.2533 26.6551C46.3868 26.6828 46.5111 26.7441 46.6144 26.8332C46.8532 27.0948 46.7491 27.5025 46.6992 27.8532C46.6493 28.2038 46.7705 28.6756 47.1269 28.687C47.3079 28.6927 47.4796 28.563 47.6571 28.5972C47.7574 28.6308 47.8417 28.7004 47.8937 28.7926C47.9457 28.8847 47.9617 28.9929 47.9386 29.0961C47.8875 29.3007 47.804 29.4959 47.6913 29.6741C47.4524 30.1962 47.4149 30.7881 47.5859 31.3362C47.7569 31.8843 48.1244 32.3498 48.6179 32.6433"
      fill="#2F2E41"
    />
    <path
      d="M75.5562 81H22.3217C22.2895 80.9934 22.2605 80.9759 22.2397 80.9505C22.2189 80.925 22.2075 80.8932 22.2075 80.8603C22.2075 80.8274 22.2189 80.7955 22.2397 80.7701C22.2605 80.7446 22.2895 80.7271 22.3217 80.7206H75.5562C75.5885 80.7271 75.6174 80.7446 75.6382 80.7701C75.659 80.7955 75.6704 80.8274 75.6704 80.8603C75.6704 80.8932 75.659 80.925 75.6382 80.9505C75.6174 80.9759 75.5885 80.9934 75.5562 81Z"
      fill="#CCCCCC"
    />
    <defs>
      <filter
        id="filter0_d_32_1763"
        x="0.454102"
        y="17.6476"
        width="59.1338"
        height="38.1077"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.059 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_32_1763"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_32_1763"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_32_1763"
        x="38.8125"
        y="17.6476"
        width="59.1338"
        height="38.1077"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.059 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_32_1763"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_32_1763"
          result="shape"
        />
      </filter>
    </defs>
  </SVG>
)

export default withIconStyles(IconEfficacyAddOn)
